<template>
    <div id="divPaymentProcessing" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <iframe id="processingIframe" :src="processingIframeSrc" class="processing-iframe" ref="processingIframe" scrolling="no" 
            @load="iframeLoaded" title="Payment Processing" />

        <back-to-top bottom="50px" right="50px" visibleoffset="300">
            <button type="button" class="btn btn-info btn-to-top"><v-icon name="angle-up" class="icon-2x angle-up" /></button>
        </back-to-top>
    </div>
</template>

<script>
import axios from "axios";
import BackToTop from 'vue-backtotop';
import iFrameResize from 'iframe-resizer/js/iframeResizer.min.js';

export default {
    name: 'Payment Processing',
    components: {
        BackToTop 
    },
    data() {
        return {
            processingIframeSrc: '',
            managePaymentMethods: ''
        }
    },
    mounted() {
        this.getProcessingRedirectLink();
    },
    methods: {
        getProcessingRedirectLink() {
            var pageLink = window.location.href;

            var routeQuery = this.$route.query.ManagePaymentMethods;
            this.managePaymentMethods = routeQuery === undefined ? null : routeQuery;

            axios({
                method: "POST",
                url: this.$httpAxiosBaseUrl() + "Payment/GetProcessingDataAndRedirectLink",
                data: {
                    pageUrl: pageLink,
                    manageAccounts: this.managePaymentMethods,
                    renderPagesInIframe: this.$store.getters.getRenderPagesInIframe,
                    isDesktop: this.$store.getters.getIsDesktop
                }
            }).then(result => {
                var response = result.data;
                if (response !== '' && response.startsWith('http')) {
                    this.processingIframeSrc = response;
                    this.$router.push({ name: 'Payment Processing', query: { ManagePaymentMethods: this.manageAccounts } });
                } else {
                    this.$toasted.global.error(response);
                    this.$announcer.set(message);
                }
            }, error => {
                console.log(error);
            });
        },
        iframeLoaded() {
            iFrameResize({ log: false, checkOrigin: false, minHeight: 700, }, "#processingIframe");
        }
    }
}
</script>

<style scoped>
.processing-iframe {
    border: none;
    width: 1px;
    min-width: 100%;
}
</style>


